<div class="w-100 h-100 gates">
  <div *ngIf="!gates.length" class="font--xxl-18 color-body-text padding-xxl--left-32">Gates</div>
  <div *ngIf="gates.length" class="font--xxl-18 color-body-text padding-xxl--left-32">Gates({{ gates.length }})</div>
  <div class="line margin-xxl--top-24"></div>

  <div class="flex flex-column padding-xxl--left-32">
    <div class="flex justify-content-start margin-xxl--top-16 margin-xxl--bottom-16 add-new">
      <button
        *ngIf="!isAddingNewGate"
        class="button-round-small font--xxl-12 font-500 color-dark-blue background-white border-blue-button"
        [ngClass]="{
          'button-disabled disabled-opacity': !isEdit
        }"
        (click)="toggleIsAddingNewGate($event)"
      >
        + Add New Gate
      </button>
      <div class="flex flex-column" *ngIf="isAddingNewGate">
        <input
          type="text"
          class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
          [(ngModel)]="newGateName"
          placeholder="Enter gate name"
        />
        <div class="flex justify-content-end margin-xxl--top-16">
          <button
            class="button-round-small font--xxl-12 font-500 color-dark-blue background-white"
            (click)="toggleIsAddingNewGate($event)"
          >
            Cancel
          </button>
          <button
            class="button-round-small font--xxl-12 font-500 color-dark-blue background-white border-blue-button"
            (click)="addGate()"
          >
            Add
          </button>
        </div>
      </div>
    </div>
    <div class="flex flex-column container-list margin-xxl--right-32">
      <div
        *ngFor="let gate of gates; let i = index"
        class="flex justify-content-between align-items-center capitalize gate-list-item color-dark-blue list-view-dots-show-hover"
      >
        {{ gate.name }}
        <div *ngIf="isEdit" (click)="showContextMenu(i)" class="cursor-pointer">
          <img src="../../../../assets/images/icons/dots.svg" alt="" />
        </div>
        <div
          [ngStyle]="{
            opacity: openContextMenu && gateIndex === i ? '1' : '0',
            'pointer-events': openContextMenu && i === gateIndex ? 'all' : 'none'
          }"
          (mouseleave)="openContextMenu = false"
          class="dots flex flex-column justify-content-center"
        >
          <div (click)="removeGate(i)" class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer">
            Delete Gate
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
